import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { authApiClient } from '../../../utils/axios';
import { showSnackbar } from '../../../api/snackbarSlice';
import { Button, Grid, Stack, Typography } from '@mui/material';
import logo from '../../../assets/logo/marmin_logo.png';
import CustomTextInput from '../../../components/CustomTextInput';
import { loginSuccess } from '../../../api/auth/authSlice';

const OTPVerificationForm = ({ email, isLogin }) => {
  const [loading, setLoading] = useState(false);
  const [timer, setTimer] = useState(120);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const {
    control,
    handleSubmit,
    formState: { errors },
    setValue,
    watch,
    trigger,
    setError,
  } = useForm({
    defaultValues: {
      email: email,
      otp: '',
    },
  });

  const onSubmit = async (data) => {
    setLoading(true);
    const route = isLogin ? '/login' : '/verify-otp';
    authApiClient
      .post(route, data)
      .then((res) => {
        if (!isLogin) {
          dispatch(showSnackbar({ message: 'Successfully verified', severity: 'success' }));
          navigate('/login', { replace: true });
        } else {
          localStorage.setItem('AUTH_TOKEN', res.data.token);
          dispatch(loginSuccess());
          navigate(`/documents`, { replace: true });
        }
      })
      .catch((err) => {
        if (err?.response?.data?.errors?.otp) {
          setError('otp', { message: err?.response?.data?.errors?.otp });
        } else {
          dispatch(
            showSnackbar({
              message: err?.response?.data?.errors?.message ?? 'Error verifying OTP',
              severity: 'error',
            }),
          );
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    if (timer > 0) {
      const countdown = setInterval(() => {
        setTimer(timer - 1);
      }, 1000);
      return () => clearInterval(countdown);
    }
  }, [timer]);

  const handleResendOtp = () => {
    authApiClient
      .post('/generate-otp', { email: email, isLogin })
      .then((res) => {
        dispatch(showSnackbar({ message: 'OTP sent successfully', severity: 'success' }));
        setTimer(120);
      })
      .catch((err) => {
        dispatch(
          showSnackbar({
            message: err?.response?.data?.errors?.message ?? 'Error sending OTP. Please try again.',
            severity: 'error',
          }),
        );
      });
  };

  return (
    <>
      <Stack sx={{ alignItems: 'center', mb: 4 }}>
        <img src={logo} alt="logo" width="50%" />
      </Stack>

      <Stack spacing={2}>
        <CustomTextInput name="email" label="Email" control={control} errors={errors} disabled={true} />
        <CustomTextInput name="otp" label="OTP" control={control} errors={errors} />
        <Button type="button" variant="contained" className="submit" onClick={handleSubmit(onSubmit)}>
          {loading ? 'Verifying...' : isLogin ? 'Login' : 'Verify Account'}
        </Button>
        <Grid container spacing={2} sx={{ justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography variant="body2">
            <Link to="/login" style={{ textDecoration: 'none' }}>
              Back to Login
            </Link>
          </Typography>
          {timer > 0 ? (
            <Typography variant="body2" color="textSecondary" align="center">
              Resend OTP in {Math.floor(timer / 60)}:{String(timer % 60).padStart(2, '0')}
            </Typography>
          ) : (
            <Button onClick={handleResendOtp} align="left" variant="text" color="primary">
              Resend OTP
            </Button>
          )}
        </Grid>
      </Stack>
    </>
  );
};
export default OTPVerificationForm;
